import type { TFunction } from 'next-i18next';
import type { BathroomCount } from 'domain/listing/value-objects';
import { LOCALE_COMMON_PATHS } from 'types/locales';

export type BathroomCountFormat = 'short' | 'long';

const PLACEHOLDER = '--';

export function formatBathroomCount(bathrooms: BathroomCount, format: BathroomCountFormat, t: TFunction): string {
  if (!bathrooms.hasValue) {
    return PLACEHOLDER;
  }

  const translationKey = format === 'short'
    ? LOCALE_COMMON_PATHS.STATS_BATHROOMS_SHORT
    : LOCALE_COMMON_PATHS.STATS_BATHROOMS_LONG;
  
  return t(translationKey, {
    count: bathrooms.value,
    defaultValue: `${bathrooms.value} ${format === 'short' ? 'ba' : 'Bath'}`,
  });
}
